module.exports = __webpack_public_path__ + "static/media/check-circle.faabe87c.svg";